import React from 'react';
import { motion } from 'framer-motion';
const volumi = [{
  num: '1',
  title: 'Didattica per Competenze e Normativa (UDA)',
  desc: 'Programmazione annuale, modelli UDA pronti e gestione delle 33 ore di Educazione Civica. ✅ Apri, adatta e consegna al Dirigente con sicurezza.'
}, {
  num: '2',
  title: 'Fondamenti di Contabilità e IVA',
  desc: 'Dalla prima nota al registro IVA. Percorsi graduati con normativa fiscale 2025/2026. ✅ Pronti per la fotocopia o lo schermo.'
}, {
  num: '3',
  title: "Il Bilancio d'Esercizio",
  desc: 'Stato Patrimoniale, Conto Economico, analisi per indici e principi OIC con casi reali. ✅ 5 percorsi sul Bilancio pronti per domani mattina.'
}, {
  num: '4',
  title: 'Finanza Aziendale e Controllo di Gestione',
  desc: 'Costi, Budget, Break Even Point e analisi delle performance aziendali. ✅ Finalmente coinvolge davvero i ragazzi.'
}, {
  num: '5',
  title: 'Diritto Commerciale e Mercati Finanziari',
  desc: "Società di capitali, contratti d'impresa, Borsa e strumenti finanziari. ✅ Percorsi pronti: le società, i contratti, i mercati, la finanza."
}, {
  num: '6',
  title: 'Guida alla Seconda Prova — Maturità 2025/2026',
  desc: "Simulazioni complete, casi aziendali reali e griglie ministeriali pronte all'uso. ✅ I tuoi studenti entrano all'esame preparati. Tu entri sereno."
}];
export function TomiSection() {
  return <section className="py-10 sm:py-12 px-4 bg-[#0d0d17] relative border-t border-brand-orange/10" data-id="element-260">
      <div className="max-w-5xl mx-auto" data-id="element-261">
        <div className="text-center mb-8" data-id="element-262">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream mb-4" data-id="element-263">
            I 6 Volumi dell'Opera Omnia
          </motion.h2>
          <p className="text-xl text-brand-gold font-bold" data-id="element-264">
            Oltre 400 pagine di contenuto reale, pronto all'uso da oggi stesso.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-265">
          {volumi.map((v, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card border border-white/10 p-6 rounded-2xl relative overflow-hidden group hover:border-brand-orange/40 transition-colors" data-id="element-266">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand-orange/10 transition-colors" data-id="element-267">
                {v.num}
              </div>
              <div className="relative z-10" data-id="element-268">
                <div className="inline-block bg-brand-orange text-white text-xs font-black px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-269">
                  Volume {v.num}
                </div>
                <h3 className="text-xl font-bold text-brand-cream mb-3 leading-tight" data-id="element-270">
                  {v.title}
                </h3>
                <p className="text-gray-400 text-sm font-medium leading-relaxed" data-id="element-271">
                  {v.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}